import { render, staticRenderFns } from "./UpdateCard.vue?vue&type=template&id=2056ca41&scoped=true&"
import script from "./UpdateCard.vue?vue&type=script&lang=js&"
export * from "./UpdateCard.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCard.vue?vue&type=style&index=0&id=2056ca41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056ca41",
  null
  
)

export default component.exports